import * as angular from "angular";

/**
 * AV-17958: the activity history dialog's data, from the Laravel
 * /v2/activity endpoints (admin only). `range` is 1|7|30|90 days and
 * `bucket` is day|week; the server does the bucketing.
 */
export class AdminActivityService {
    private root = "/v2/activity";

    constructor(private $http: any) {}

    campaign(
        campaignid: number | string,
        range: number,
        bucket: string
    ): Promise<object> {
        return this.$http.get(this.root + "/campaign/" + campaignid, {
            params: { range: range, bucket: bucket },
        });
    }
    organisation(
        oid: number | string,
        range: number,
        bucket: string
    ): Promise<object> {
        return this.$http.get(this.root + "/organisation/" + oid, {
            params: { range: range, bucket: bucket },
        });
    }
}

angular
    .module("vcServices")
    .service("AdminActivityService", AdminActivityService);
